import React from 'react';
import { Box, Tooltip } from '@mui/material';
import { AccessTime as ClockIcon } from '@mui/icons-material';
import { formatElapsedHms, parseIncidentStart } from '../../Utils/elapsedTimer';
import { Incident } from '../../Types/Incident';

interface IncidentElapsedTimerProps {
  incident: Incident;
  now: number;
}

const IncidentElapsedTimer: React.FC<IncidentElapsedTimerProps> = ({ incident, now }) => {
  const startMs = parseIncidentStart(incident);
  if (Number.isNaN(startMs)) return null;

  const elapsed = formatElapsedHms(startMs, now);

  return (
    <Tooltip title="Elapsed since incident start" arrow>
      <Box
        aria-label={`Elapsed time ${elapsed}`}
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 0.5,
          px: 1,
          py: 0.25,
          borderRadius: '12px',
          height: 22,
          bgcolor: 'rgba(120, 144, 156, 0.08)',
          border: '1px solid rgba(120, 144, 156, 0.30)',
          color: 'rgba(69, 90, 100, 0.87)',
          fontVariantNumeric: 'tabular-nums',
          fontSize: '0.8125rem',
          fontWeight: 600,
          lineHeight: 1,
          whiteSpace: 'nowrap',
          userSelect: 'none',
        }}
      >
        <ClockIcon sx={{ fontSize: 14, color: 'inherit', opacity: 0.7 }} />
        {elapsed}
      </Box>
    </Tooltip>
  );
};

export default IncidentElapsedTimer;
